exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DownloadContentButtons[data-v-627f818b] {\n  display: flex;\n  justify-content: right;\n}", ""]);

// exports
